// extracted by mini-css-extract-plugin
module.exports = {"button":"PasswordPage_button__2CZm9"};